<template>
  <div class="experience-section">
    <div class="experience-card">
      <div class="card-header">
        <h3>{{ t("experiences_title") }}</h3>
      </div>
      <ul class="experience-list">
        <li v-for="(experience, index) in translatedExperiences" :key="index" class="experience-item">
          <div class="details">
            <h4 class="company-name">{{ experience.company }}</h4>
            <p class="role">{{ experience.position }}</p>
            <span class="date">{{ experience.date }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import i18n from "@/i18n/i18n";

export default {
  setup() {
    const experiences = computed(() => i18n.get("experiences"));
    const translatedExperiences = computed(() =>
      experiences.value.map((experience) => ({
        ...experience,
        position: i18n.get(experience.position),
        date: i18n.get(experience.date),
      }))
    );
    const t = (key) => i18n.get(key);

    return {
      translatedExperiences,
      t,
    };
  },
};
</script>

<style scoped>
.experience-section {
  margin-left: 16px;
  font-family: "Helvetica Nos Micro Regular", sans-serif;
}

.experience-card {
  border: 0.1px solid #e5e7eb;
  border-radius: 12px;
  padding: 48px;
}

.card-header {
  margin-bottom: 0px;
  text-align: center;
  border-bottom: 0.1px solid #e5e7eb;
}

.card-header h3 {
  font-family: "Europa Grotesk SH Med", sans-serif;
  font-size: 1.2rem;
  color: #222;
  margin: 8px 8px 24px 8px;
}

.experience-list {
  list-style: none;
  padding: 0;
  margin: 0;
  font-family: "Helvetica Nos Micro Regular", sans-serif;
}

.experience-item {
  font-family: "Europa Grotesk SH Med", sans-serif;
  padding: 12px 12px 12px 12px;
  border-bottom: 0.1px solid #e5e7eb;
}

.experience-item:last-child {
  border-bottom: none;
}

.company-name {
  font-family: "Europa Grotesk SH Med", sans-serif;
  font-size: 1rem;
  font-weight: bold;
  color: #111827;
  margin: 0;
}

.role {  
  font-family: "Helvetica Nos Micro Regular", sans-serif;
  font-weight: lighter;
  font-size: 0.9rem;
  color: #20252e;
  margin: 0;
}

.date {
  font-family: "Helvetica Nos Micro Regular", sans-serif;
  font-weight: lighter;
  font-size: 0.75rem;
  color: #20252e;
  opacity: 0.5;
  margin: 0;
}

/* Responsividade */
@media (max-width: 768px) {
  .experience-card {
    border: none;

  }

  .experience-item {
    padding: 4px 0;
    border-bottom: 0.1px solid #e5e7eb;
  }

  .company-name {
    font-size: 0.9rem;
  }
}
</style>
